// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcb_a bhc_a bhc_r bhc_j","ModeratorInvitationListItem__left":"bcb_b bhc_a bhc_j","ModeratorInvitationListItem__note":"bcb_c bhc_fi"};